import { z } from "zod/v4";
import { memberNoteSchema } from "../schemas/note";
import { fetchApi, fetchVoid } from "./internal";

export const notes = {
	list: (clubId: string, memberId: string) =>
		fetchApi(`/clubs/${clubId}/members/${memberId}/notes`, z.array(memberNoteSchema)),
	create: (clubId: string, memberId: string, content: string) =>
		fetchApi(`/clubs/${clubId}/members/${memberId}/notes`, memberNoteSchema, {
			method: "POST",
			body: JSON.stringify({ content }),
		}),
	delete: (clubId: string, memberId: string, noteId: string) =>
		fetchVoid(`/clubs/${clubId}/members/${memberId}/notes/${noteId}`, {
			method: "DELETE",
		}),
};
